export class HLGError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class LaunchError extends HLGError {
  constructor(message: string) {
    super(message);
  }
}
